<!-- Notifications toggle -->
<button mat-icon-button (click)="openPanel()" #notificationsOrigin>
    <mat-icon [matBadge]="unreadCount" matBadgeColor="warn" matBadgeSize="small"
        [matBadgeHidden]="unreadCount == 0">notifications</mat-icon>
</button>

<!-- Notifications panel -->
<ng-template #notificationsPanel>

    <div class="dialog-content-wrapper-notification">

        <!-- Header -->
        <!-- <div class="flex flex-shrink-0 items-center py-4 pr-4 pl-6 bg-primary text-on-primary">
            <div class="sm:hidden -ml-1 mr-3">
                <button mat-icon-button (click)="closePanel()">
                    <mat-icon class="icon-size-5 text-current">close</mat-icon>
                </button>
            </div>
            <div class="text-lg font-medium leading-10">Notifications</div>
            <div class="ml-auto">
                <button mat-icon-button [matTooltip]="'Mark all as read'" [disabled]="unreadCount === 0"
                    (click)="markAllAsRead()">
                    <mat-icon class="icon-size-5 text-current">drafts</mat-icon>
                </button>
            </div>
        </div> -->

        <mat-toolbar matDialogTitle class="toolbar m-0" fxFlex="1 0 auto" fxLayout="row">

            <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
                <span>{{"NOTIFICATION.NOTIFICATIONS" | translate}}</span>
                <!-- <button mat-icon-button (click)="closePanel()" aria-label="Close Dialog">
                    <mat-icon>close</mat-icon>
                </button> -->
                <div>
                    <button mat-icon-button [matTooltip]="'NOTIFICATION.MARK_ALL_AS_READ' | translate "
                        [disabled]="unreadCount === 0 || notificationsUnread?.length == 0" (click)="markAllAsRead()">
                        <mat-icon class="icon-size-5 text-current">visibility</mat-icon>
                    </button>
                    <button mat-icon-button [matTooltip]="'NOTIFICATION.MARK_ALL_AS_UNREAD' | translate "
                        [disabled]="unreadCount === notificationsUnread.length" (click)="markAllAsUnRead()">
                        <mat-icon class="icon-size-5 text-current">visibility_off</mat-icon>
                    </button>
                    <button mat-icon-button [matTooltip]="'NOTIFICATION.CLEAR_ALL' | translate "
                        [disabled]="notificationsUnread?.length == 0" (click)="clearAll()">
                        <mat-icon class="icon-size-5 text-current">clear_all</mat-icon>
                    </button>
                </div>
            </div>

        </mat-toolbar>


        <!-- Content -->
        <!-- <div class="relative flex flex-col flex-auto sm:max-h-120 divide-y overflow-y-auto bg-card"> -->
        <div mat-dialog-content class="bg-card notification-content">
            <mat-tab-group dynamicHeight mat-stretch-tabs="false" mat-align-tabs="center"
                (selectedTabChange)="onChangeTabs($event)">
                <mat-tab label="{{ 'NOTIFICATION.INBOX' | translate }}">
                    <!-- Notifications List -->
                    <div class="notification-list">
                        <ng-container *ngFor="let notification of notificationsUnread; trackBy: trackByFn">
                            <div
                                class="notification-item flex group hover:bg-gray-50 dark:hover:bg-opacity-10 transition duration-300 ease-in-out">
                                <!-- Notification Content -->
                                <div class="flex flex-auto py-4 px-6">
                                    <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                                </div>


                            </div>
                            <!-- Notification Content Template -->
                            <ng-template #notificationContent>
                                <div class="flex flex-col flex-auto">
                                    <div fxLayout="row" fxLayoutAlign="space-between center">
                                        <ng-container *ngIf="notification.notification?.name">
                                            <mat-chip-list>
                                                <mat-chip (click)="navigateTo(notification, notification.notification.source, notification.notification.idSource)">
                                                    <ng-container *ngIf="notification.statut === statut.Created">
                                                        <span 
                                                            style="width: 10px; height: 10px; background-color: #2298D0; border-radius: 50%; display: inline-block; margin-right: 8px;">
                                                        </span>
                                                    </ng-container>
                                                    <strong [innerHTML]="notification.notification.name"></strong>
                                                </mat-chip>
                                            </mat-chip-list>
                                        </ng-container>
                                        
                                        <div fxLayout="row" fxLayoutAlign="end" class="w-20-p">
                                            <button class="w-6 h-6 min-h-6" mat-icon-button
                                                (click)="toggleRead(notification)"
                                                [matTooltip]="notification.statut === statut.Created ? ('NOTIFICATION.MARK_AS_READ' | translate) : ('NOTIFICATION.MARK_AS_UNREAD' | translate)">
                                                <mat-icon class="logo-icon s-24 mr-16"
                                                    [style.color]="notification.statut === statut.Viewed ? '#9AC350' : '#2298D0'">
                                                    {{notification.statut === statut.Viewed ? 'visibility_off' :
                                                    'visibility' }}
                                                </mat-icon>
                                            </button>
                                            <!-- Remove Button -->
                                            <button
                                                class="w-6 h-6 min-h-6 sm:opacity-0 sm:group-hover:opacity-100 transition-opacity"
                                                mat-icon-button (click)="close(notification)"
                                                [matTooltip]="'NOTIFICATION.CLEAR' | translate ">
                                                <mat-icon class="logo-icon s-24 mr-16"
                                                    [style.color]="'red'">close</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                    <ng-container *ngIf="notification.notification?.description">
                                        <div class="text-gray-600 dark:text-gray-400 line-clamp-2"
                                            [innerHTML]="notification.notification.description"></div>
                                    </ng-container>
                                    <div class="mt-2 text-sm leading-none text-secondary">
                                        {{ notification.notification?.date | date: 'dd/MM/yyyy HH:mm' }}
                                    </div>
                                </div>
                            </ng-template>
                        </ng-container>
                    </div>
                    <!-- No Notifications -->
                    <ng-container *ngIf="!notificationsUnread || !notificationsUnread.length">
                        <div fxLayout="column" fxLayoutAlign="center center" class="no-notifications">
                            <div class="icon-container">
                                <mat-icon class="icon-notif">notifications</mat-icon>
                            </div>
                            <div class="font-weight-700 mt-4">{{ "NOTIFICATION.NO_NOTIFICATIONS" | translate }}</div>
                            <div class="text-secondary mt-2">{{ "NOTIFICATION.NO_NOTIFICATIONS_MESSAGE" | translate }}
                            </div>
                        </div>
                    </ng-container>
                </mat-tab>
                <mat-tab label="{{'NOTIFICATION.WATCHING' | translate}}">
                    <!-- Notifications List -->
                    <div class="notification-list">
                        <ng-container *ngFor="let notification of notificationsClosed; trackBy: trackByFn">
                            <div
                                class="notification-item flex group hover:bg-gray-50 dark:hover:bg-opacity-10 transition duration-300 ease-in-out">
                                <!-- Notification Content -->
                                <div class="flex flex-auto py-4 px-6">
                                    <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                                </div>


                            </div>
                            <!-- Notification Content Template -->
                            <ng-template #notificationContent>
                                <div class="flex flex-col flex-auto">
                                    <div fxLayout="row" fxLayoutAlign="space-between center">
                                        <ng-container *ngIf="notification.notification?.name">
                                            <mat-chip-list>
                                                <mat-chip>
                                                    <strong [innerHTML]="notification.notification.name"></strong>
                                                </mat-chip>
                                            </mat-chip-list>
                                        </ng-container>

                                    </div>
                                    <ng-container *ngIf="notification.notification?.description">
                                        <div class="text-gray-600 dark:text-gray-400 line-clamp-2"
                                            [innerHTML]="notification.notification.description"></div>
                                    </ng-container>
                                    <div class="mt-2 text-sm leading-none text-secondary">
                                        {{ notification.notification?.date | date: 'dd/MM/yyyy HH:mm' }}
                                    </div>
                                </div>
                            </ng-template>
                        </ng-container>
                    </div>
                    <!-- No Notifications -->
                    <ng-container *ngIf="!notificationsClosed || !notificationsClosed.length">
                        <div fxLayout="column" fxLayoutAlign="center center" class="no-notifications">
                            <div class="icon-container">
                                <mat-icon class="icon-notif">notifications</mat-icon>
                            </div>
                            <div class="font-weight-700 mt-4">{{ "NOTIFICATION.NO_NOTIFICATIONS" | translate }}</div>
                            <div class="text-secondary mt-2">{{ "NOTIFICATION.NO_NOTIFICATIONS_MESSAGE" | translate }}
                            </div>
                        </div>
                    </ng-container>

                </mat-tab>

            </mat-tab-group>
        </div>

    </div>

</ng-template>